<template>
  <Teleport to="body">
    <Transition name="sne-fade">
      <div v-if="current" class="sne-overlay">
        <div class="sne-box" role="alertdialog" aria-live="assertive" aria-label="Adiamento chegou ao limite">
          <div class="sne-icon" aria-hidden="true">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2M5 3 2 6M22 6l-3-3"/></svg>
          </div>
          <div class="sne-title">Adiamento chegou ao limite</div>
          <div class="sne-desc">
            A conversa com <strong>{{ current.contactName || 'o contato' }}</strong> estava adiada até
            <strong>{{ untilLabel }}</strong>. Ela voltou pra <b>Aberta</b>.
          </div>
          <div v-if="pendingSnoozeAlerts.length > 1" class="sne-more">+{{ pendingSnoozeAlerts.length - 1 }} adiamento(s) vencido(s) na fila</div>
          <div class="sne-actions">
            <button type="button" class="sne-btn sne-btn--primary" @click="handleOpen">Ir para a conversa</button>
            <button type="button" class="sne-btn sne-btn--secondary" @click="dismissCurrentSnoozeAlert">Dispensar</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
// Mesmo formato do popup "Novo atendimento atribuído" (AssignmentAlertModal.vue): um aviso por vez, bloqueante.
import { computed } from 'vue'
import { pendingSnoozeAlerts, dismissCurrentSnoozeAlert } from '@/composables/useSnoozeAlerts'
import { requestOpenChat } from '@/composables/useChatTrigger'

const current = computed(() => pendingSnoozeAlerts.value[0] ?? null)

const untilLabel = computed(() => {
  if (!current.value) return ''
  const d = new Date(current.value.snoozedUntil)
  const sameDay = d.toDateString() === new Date().toDateString()
  return d.toLocaleString('pt-BR', sameDay ? { hour: '2-digit', minute: '2-digit' } : { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
})

function handleOpen() {
  if (!current.value) return
  requestOpenChat(current.value.conversationId)
  dismissCurrentSnoozeAlert()
}
</script>

<style scoped>
.sne-overlay { position: fixed; inset: 0; z-index: 10000; background: rgba(0, 0, 0, .55); display: flex; align-items: center; justify-content: center; }
.sne-box { background: var(--white); border-radius: var(--r); padding: 30px 32px; width: 380px; max-width: calc(100vw - 32px); text-align: center; box-shadow: 0 20px 60px rgba(0, 0, 0, .3); }
.sne-icon { width: 56px; height: 56px; margin: 0 auto 10px; border-radius: 50%; display: grid; place-items: center; background: rgba(139, 92, 246, .14); color: #7c3aed; }
.sne-title { font-size: 17px; font-weight: 700; color: var(--ink-80); margin-bottom: 8px; }
.sne-desc { font-size: 13px; color: var(--ink-40); line-height: 1.55; margin-bottom: 14px; }
.sne-desc strong, .sne-desc b { color: var(--ink-80); }
.sne-more { font-size: 12px; color: #7c3aed; font-weight: 600; margin-bottom: 14px; }
.sne-actions { display: flex; flex-direction: column; gap: 10px; }
.sne-btn { padding: 10px 16px; border-radius: var(--r-sm); font-weight: 600; font-size: 13px; cursor: pointer; border: none; font-family: inherit; }
.sne-btn--primary { background: var(--red); color: #fff; }
.sne-btn--secondary { background: transparent; color: var(--ink-40); border: 1.5px solid var(--ink-10); }
.sne-btn--secondary:hover { background: var(--ink-02); }
.sne-fade-enter-active, .sne-fade-leave-active { transition: opacity .15s ease; }
.sne-fade-enter-from, .sne-fade-leave-to { opacity: 0; }
</style>
